import script from "./LoginView.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginView.vue?vue&type=script&setup=true&lang=js"

import "./LoginView.vue?vue&type=style&index=0&id=1616b6b2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1616b6b2"]])

export default __exports__